export default class IncomeStatementFilterModel {
    constructor() {
        this.type = null;
        this.year = null;
        this.project_id = null;
    }
}